import canDownloadEntities from './canDownloadEntities';

export { canDownloadEntities };
